module.exports = __webpack_public_path__ + "media/flags/bg-aa63aa72.svg";